import React, { useState } from "react";
import { FaClock, FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState({ type: "idle", text: "We respond within 24 hours." });

  const handleChange = (event) => {
    const { id, value } = event.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setIsSubmitting(true);
    setStatus({ type: "idle", text: "Sending your message..." });

    try {
      const recipient = (
        process.env.REACT_APP_RECIPIENT_EMAIL || "sheshankchigumalla@gmail.com"
        
      ).trim();

      if (!recipient || !recipient.includes("@")) {
        throw new Error("Recipient email is not configured correctly.");
      }

      const response = await fetch(`https://formsubmit.co/ajax/${recipient}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          _subject: `New Contact Form Message - ${formData.name}`,
          _template: "table",
          _captcha: "false",
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          message: formData.message,
        }),
      });

      const result = await response.json();

      if (!response.ok || result.success !== "true") {
        throw new Error(result.message || "Request failed");
      }

      setStatus({
        type: "success",
        text: "Message sent! We will get back to you soon.",
      });
      setFormData({ name: "", email: "", phone: "", message: "" });
    } catch (error) {
      setStatus({
        type: "error",
        text: `Could not send message: ${error.message}`,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="section contact-section">
      <div className="section-inner">
        <div className="contact-card">
          <div className="contact-left">
            <h2 className="section-heading">Get In Touch</h2>
            <p className="contact-intro">
              Contact us for bulk orders, pricing, and export enquiries. Our
              team will respond with details tailored to your requirements.
            </p>
            <ul className="contact-details">
              <li>
                <span className="contact-icon" aria-hidden="true">
                  <FaPhoneAlt />
                </span>
                <span>+91 98494 24568</span>
              </li>
              <li>
                <span className="contact-icon" aria-hidden="true">
                  <FaEnvelope />
                </span>
                <span>srccorporation2112@gmail.com</span>
              </li>
              <li>
                <span className="contact-icon" aria-hidden="true">
                  <FaMapMarkerAlt />
                </span>
                <span>Hyderabad, Telangana, India</span>
              </li>
              <li>
                <span className="contact-icon" aria-hidden="true">
                  <FaClock />
                </span>
                <span>9 AM - 6 PM (IST)</span>
              </li>
            </ul>
          </div>
          <div className="contact-right">
            <h3 className="contact-form-title">Send a Message</h3>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="contact-field">
                <label className="contact-label" htmlFor="name">
                  Name*
                </label>
                <input
                  id="name"
                  type="text"
                  className="contact-input"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="contact-field">
                <label className="contact-label" htmlFor="email">
                  Email address*
                </label>
                <input
                  id="email"
                  type="email"
                  className="contact-input"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="contact-field">
                <label className="contact-label" htmlFor="phone">
                  Phone*
                </label>
                <input
                  id="phone"
                  type="tel"
                  className="contact-input"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="contact-field">
                <label className="contact-label" htmlFor="message">
                  Message*
                </label>
                <textarea
                  id="message"
                  className="contact-textarea"
                  rows={4}
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>
              <button type="submit" className="btn-primary contact-submit" disabled={isSubmitting}>
                {isSubmitting ? "Sending..." : "Submit"}
              </button>
              <p className={`contact-note ${status.type === "success" ? "contact-note-success" : ""} ${status.type === "error" ? "contact-note-error" : ""}`}>
                {status.text}
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;